import React from 'react';

/**
 * Row of KPI stat cards at the top of each log page.
 * Props:
 *   stats – [{ label, value, sub?, color? }]
 */
const LogStatCards = ({ stats = [] }) => (
  <div className="al-stats">
    {stats.map((s, i) => (
      <div className="al-stat-card" key={i} style={{ borderTop: `3px solid ${s.color || '#F55D00'}` }}>
        <span className="al-stat-label">{s.label}</span>
        <span className="al-stat-value" style={{ color: s.color || '#111827' }}>
          {s.value ?? '—'}
        </span>
        {s.sub && <span className="al-stat-sub">{s.sub}</span>}
      </div>
    ))}
  </div>
);

export default LogStatCards;
